/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
export default class Enquiry {
  constructor({ htmlBody }) {
    this.htmlBody = htmlBody;
    this.enquiryHeaderBtn = this.htmlBody.find('.header__enquiry__button');
    this.enquiryBtn = this.htmlBody.find('.button--enquiry');
    this.salesOfferBtn = this.htmlBody.find('.button--sales--offer');
    this.enquiryForm = this.htmlBody.find('#enquiryForm');
    this.init();
  }

  init = () => {
    this.enquiryForm.length && this.enquiry();

    // prop
    const pageURL = window.location.href;
    const lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1);
    if (lastURLSegment === '?enquire=true') {
      this.enquiryBtn.click();
    }
  };

  enquiry = () => {
    // set hidden field values
    this.enquiryForm.find('[class*=page-title-] input').val(this.enquiryForm.data('ctitle'));
    this.enquiryForm.find('[class*=page-url-] input').val(this.enquiryForm.data('curl'));

    this.enquiryHeaderBtn.fancybox({
      backFocus: false,
      infobar: false,
      modal: true,
      helpers: {
        overlay: {
          css: {
            // eslint-disable-next-line quote-props
            'background': 'rgba(48,51,52,0.9)',
          },
        },
      },
    });

    this.enquiryBtn.fancybox({
      backFocus: false,
      infobar: false,
      modal: true,
      helpers: {
        overlay: {
          css: {
            // eslint-disable-next-line quote-props
            'background': 'rgba(48,51,52,0.9)',
          },
        },
      },
    });

    this.salesOfferBtn.fancybox({
      backFocus: false,
      infobar: false,
      modal: true,
      helpers: {
        overlay: {
          css: {
            // eslint-disable-next-line quote-props
            'background': 'rgba(48,51,52,0.9)',
          },
        },
      },
    });

    // this.enquiryBtn.on('click', (e) => {
    //   e.preventDefault();
    //   this.enquiryHeaderBtn.click();
    // });
  }
}
